import { useSessionStore } from '@/src/hooks/use_session_store'
import { useEffect } from 'react'
import { updateUser } from '../data/locationUserDataProvider'
import { useSocketIoListener } from './useSocketIoListener.hook'

export const useNewAppVersionListener = () => {
  const { user, updateUserInStore } = useSessionStore()

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (user?.appReloadRequired) {
        updateUser(user.id, user.company.id, { appReloadRequired: false })
        updateUserInStore({ appReloadRequired: false })
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [user?.appReloadRequired, updateUser])

  useSocketIoListener('user.appReloadRequired', (data: { appReloadRequired: boolean }) => {
    updateUserInStore({ appReloadRequired: data.appReloadRequired })
  })
}
